import React, { useState } from "react";
import { Link } from "react-router-dom";
import useCartStore from "../store/shoppingCardStore";
import { ShoppingCart, Plus, Minus, Battery } from "lucide-react";
import styles from "../styles/Cards.module.css";

import p11 from "../images/products/pu1.1.jpg";
import p12 from "../images/products/pu1.2.jpg";
import p13 from "../images/products/pu1.3.jpg";
import p14 from "../images/products/pu1.4.jpg";

import p21 from "../images/products/pu2.1.jpg";
import p22 from "../images/products/pu2.2.jpg";
import p23 from "../images/products/pu2.3.jpg";
import p24 from "../images/products/pu2.4.jpg";

import p31 from "../images/products/pu3.1.jpg";
import p32 from "../images/products/pu3.2.jpg";
import p33 from "../images/products/pu3.3.jpg";
import p34 from "../images/products/pu3.4.jpg";

import p41 from "../images/products/pu4.1.jpg";
import p42 from "../images/products/pu4.2.jpg";
import p43 from "../images/products/pu4.3.jpg";
import p44 from "../images/products/pu4.4.jpg";

import { slugify } from "../utils/utils";

const products = [
  {
    name: "باتری یو پی اس صبا 12 ولت 18 آمپر (ناموجود)(Saba UPS 12V-18Ah)",
    slug: "battery-12v-18ah-saba-sealed-lead-acid-ups",

    image: [p11, p12, p13, p14],

    /*
     * قیمت‌ها را دستی وارد کن
     */

    // قیمت با داغی
    priceWithScrap: 0,

    // قیمت بدون داغی
    priceWithoutScrap: 0,

    info: `
<h2>خرید و قیمت باتری 12 ولت 18 آمپر صبا باتری</h2>
<p>
باتری یو پی اس صبا باتری منبعی است که با تبدیل انرژی شیمیایی
به انرژی الکتریکی، بین دو نقطه اختلاف پتانسیل الکتریکی ایجاد کرده
و برق DC تولید می‌کند.
</p>

<h3>کاربردهای باتری 12V-18Ah صبا باتری</h3>

<ul>
  <li>سیستم‌های یو پی اس</li>
  <li>لیفتراک و خودروهای برقی</li>
  <li>موتورهای برقی</li>
  <li>تابلوهای فرمان آسانسور</li>
  <li>ماشین‌های چمن‌زنی و گلف</li>
  <li>ویلچرهای برقی</li>
  <li>سایر تجهیزات الکترونیکی</li>
</ul>
`,

    infos: `
<ul>
<li><strong>نوع:</strong> سیلد لید اسید (خشک)</li>
<li><strong>ولتاژ:</strong> 12 ولت</li>
<li><strong>ظرفیت:</strong> 18 آمپر ساعت</li>
<li><strong>مقاومت داخلی:</strong> 20 میلی اهم</li>
<li><strong>ابعاد:</strong> 181×78×165 میلی‌متر</li>
<li><strong>وزن:</strong> 6.5 کیلوگرم</li>
<li><strong>تکنولوژی:</strong> باتری سیلد اسید یو پی اس</li>
<li><strong>کشور تولید کننده:</strong> ایران</li>
</ul>
`,

    id: 1,

    meta: {
      title: "خرید باتری 12 ولت 18 آمپر صبا باتری | قیمت با گارانتی | باتری۱۰۰",
      description:
        "باتری 12 ولت 18 آمپر صبا باتری مدل سیلد اسید UPS با کیفیت بالا و کاربردهای متنوع.",
      keywords:
        "باتری 12 ولت 18 آمپر, باتری یو پی اس, باتری سیلد اسید, صبا باتری",
    },
  },

  {
    name: "باتری یو پی اس صبا 12 ولت 28 آمپر(Saba UPS 12V-28Ah)",
    slug: "battery-12v-28ah-saba-ups",

    image: [p21, p22, p23, p24],

    /*
     * قیمت‌ها را دستی وارد کن
     */

    priceWithScrap: 5545000,
    priceWithoutScrap: 7500000,

    info: `
<h2>خرید و قیمت باتری یو پی اس صبا 28 آمپر 12 ولت</h2>

<p>
باتری یو پی اس صبا 28 آمپر 12 ولت با طراحی بدون نیاز به تعمیر
و نگهداری، منبعی قابل اعتماد برای تأمین جریان الکتریکی
در محیط‌های حساس می‌باشد.
</p>

<h3>کاربردهای باتری 28 آمپر صبا</h3>

<ul>
  <li>سیستم‌های یو پی اس و سرورها</li>
  <li>چرخ‌دستی‌های گلف</li>
  <li>ماشین‌های چمن‌زنی برقی</li>
  <li>خودروهای برقی سواری کودکان</li>
  <li>سیستم‌های روشنایی قابل حمل</li>
  <li>اسکوترهای برقی</li>
  <li>لیفتراک‌های برقی</li>
</ul>
`,

    infos: `
<ul>
<li><strong>نوع:</strong> سیلد اسید (خشک)</li>
<li><strong>ولتاژ:</strong> 12 ولت</li>
<li><strong>ظرفیت:</strong> 28 آمپر ساعت</li>
<li><strong>ابعاد:</strong> استاندارد یو پی اس</li>
<li><strong>وزن:</strong> متناسب با ظرفیت</li>
<li><strong>گارانتی:</strong> 12 ماه ضمانت تعویض</li>
<li><strong>تکنولوژی:</strong> سیلد لید اسید</li>
<li><strong>کشور تولید کننده:</strong> ایران</li>
</ul>
`,

    id: 2,

    meta: {
      title:
        "خرید باتری یو پی اس صبا 28 آمپر 12 ولت | قیمت با گارانتی | باتری۱۰۰",
      description:
        "باتری یو پی اس صبا 28 آمپر 12 ولت با کیفیت بالا و گارانتی 12 ماهه.",
      keywords: "باتری یو پی اس 28 آمپر, باتری 12 ولت صبا, باتری سیلد اسید",
    },
  },

  {
    name: "باتری یو پی اس صبا 12 ولت 42 آمپر(Saba UPS 12V-42Ah)",
    slug: "battery-42ah-saba-ups",

    image: [p31, p32, p33, p34],

    /*
     * قیمت‌ها را دستی وارد کن
     */

    priceWithScrap: 8635000,
    priceWithoutScrap: 12100000,

    info: `
<h2>خرید و قیمت باتری 42 آمپر یو پی اس صبا</h2>

<p>
باتری 42 آمپر یو پی اس صبا به عنوان منبع پشتیبان اضطراری
برق در سیستم‌های حیاتی کاربرد دارد.
</p>

<h3>کاربردهای اصلی</h3>

<ul>
  <li>تجهیزات پزشکی حیاتی</li>
  <li>دستگاه‌های تصویربرداری پزشکی</li>
  <li>سیستم‌های امنیتی</li>
  <li>سیستم‌های صنعتی</li>
  <li>مراکز داده و سرورها</li>
</ul>
`,

    infos: `
<ul>
<li><strong>نوع:</strong> سرب-اسید مهر و موم شده (VRLA)</li>
<li><strong>ولتاژ:</strong> 12 ولت</li>
<li><strong>ظرفیت:</strong> 42 آمپر ساعت</li>
<li><strong>ابعاد:</strong> 197×166×169 میلی‌متر</li>
<li><strong>وزن:</strong> 13.1 کیلوگرم</li>
<li><strong>کاربرد اصلی:</strong> سیستم‌های یو پی اس</li>
<li><strong>تکنولوژی:</strong> VRLA</li>
<li><strong>گارانتی:</strong> 18 ماهه</li>
</ul>
`,

    id: 3,

    meta: {
      title:
        "خرید باتری 42 آمپر یو پی اس صبا | قیمت با گارانتی 18 ماهه | باتری۱۰۰",
      description: "باتری 42 آمپر یو پی اس صبا با گارانتی 18 ماهه.",
      keywords: "باتری 42 آمپر, باتری یو پی اس, صبا باتری",
    },
  },

  {
    name: "باتری یو پی اس صبا 12 ولت 65 آمپر(Saba UPS 12V-65Ah)",
    slug: "battery-12v-65ah-saba-ups",

    image: [p41, p42, p43, p44],

    /*
     * قیمت‌ها را دستی وارد کن
     */

    priceWithScrap: 12390000,
    priceWithoutScrap: 18900000,

    info: `
<h2>خرید و قیمت باتری یو پی اس 12 ولت 65 آمپر صبا باتری</h2>

<p>
باتری یو پی اس 12 ولت 65 آمپر صبا باتری با تکنولوژی سیلد اسید،
مناسب برای اتصال به دستگاه‌های UPS می‌باشد.
</p>

<h3>کاربردهای باتری 12V-65Ah</h3>

<ul>
  <li>ادارات و شرکت‌ها</li>
  <li>مراکز درمانی</li>
  <li>کارگاه‌ها و کارخانه‌ها</li>
  <li>منازل</li>
  <li>مراکز بانکی و مالی</li>
</ul>
`,

    infos: `
<ul>
<li><strong>نوع:</strong> سیلد اسید (VRLA)</li>
<li><strong>ولتاژ:</strong> 12 ولت</li>
<li><strong>ظرفیت:</strong> 65 آمپر ساعت</li>
<li><strong>تکنولوژی:</strong> سرب-اسید مهر و موم شده</li>
<li><strong>کاربرد اصلی:</strong> سیستم‌های یو پی اس</li>
<li><strong>کشور تولید کننده:</strong> ایران</li>
</ul>
`,

    id: 4,

    meta: {
      title:
        "خرید باتری یو پی اس 12 ولت 65 آمپر صبا | قیمت با گارانتی | باتری۱۰۰",
      description: "باتری یو پی اس 12 ولت 65 آمپر صبا باتری.",
      keywords: "باتری 65 آمپر, باتری یو پی اس صبا, باتری سیلد اسید",
    },
  },
];

const UpsCards = () => {
  const { items, itemscount, addItem, removeItem } = useCartStore();

  /*
   * وضعیت انتخاب با داغی / بدون داغی
   *
   * ساختار:
   * {
   *   1: "with",
   *   2: "without",
   *   3: "with"
   * }
   */

  const [batteryOptions, setBatteryOptions] = useState({});

  const getBatteryOption = (productId) => {
    return batteryOptions[productId] || "with";
  };

  const setBatteryOption = (productId, option) => {
    setBatteryOptions((prev) => ({
      ...prev,
      [productId]: option,
    }));
  };

  /*
   * گرفتن قیمت بر اساس انتخاب کاربر
   */

  const getCurrentPrice = (product) => {
    const option = getBatteryOption(product.id);

    if (option === "without") {
      return product.priceWithoutScrap;
    }

    return product.priceWithScrap;
  };

  /*
   * بررسی موجود بودن
   */

  const isProductAvailable = (productName) => {
    return !productName.includes("(ناموجود)");
  };

  /*
   * آیا محصول داخل سبد است؟
   */

  const isInCart = (product) => {
    return items.some((item) => item.id === product.id);
  };

  /*
   * افزودن محصول به سبد
   */

  const handleAddToCart = (product, e) => {
    e.preventDefault();

    const batteryOption = getBatteryOption(product.id);
    const currentPrice = getCurrentPrice(product);

    addItem({
      ...product,

      // قیمت نهایی
      price: currentPrice,

      // نوع خرید
      batteryOption,

      // ذخیره جداگانه قیمت‌ها
      priceWithScrap: product.priceWithScrap,
      priceWithoutScrap: product.priceWithoutScrap,
    });
  };

  /*
   * افزایش تعداد
   */

  const handleIncrease = (product, e) => {
    e.preventDefault();

    const batteryOption = getBatteryOption(product.id);
    const currentPrice = getCurrentPrice(product);

    addItem({
      ...product,
      price: currentPrice,
      batteryOption,
      priceWithScrap: product.priceWithScrap,
      priceWithoutScrap: product.priceWithoutScrap,
    });
  };

  return (
    <div className={styles.cardsContainer}>
      {/* Header */}

      <div className={styles.header}>
        <Battery className={styles.headerIcon} size={28} />

        <h2>محصولات باتری یو پی اس (UPS)</h2>

        <p>با کیفیت‌ترین باتری‌ها با گارانتی معتبر</p>

        <Link to="/محصولات/" className={styles.viewAllBtn}>
          نمایش تمام محصولات باتری یو پی اس
        </Link>
      </div>

      {/* Products */}

      <div className={styles.productsGrid}>
        {products.map((product) => {
          const currentOption = getBatteryOption(product.id);

          const currentPrice = getCurrentPrice(product);

          const inCart = isInCart(product);

          const quantity = itemscount[product.id] || 0;

          return (
            <div key={product.id} className={styles.productCard}>
              {/* تصویر */}

              <Link
                to={`/product/${slugify(product.name)}`}
                className={styles.productImageLink}
              >
                <img
                  src={product.image[0]}
                  alt={product.name}
                  className={styles.productImage}
                  loading="lazy"
                />

                <div className={styles.productOverlay}>
                  <span>مشاهده جزئیات</span>
                </div>
              </Link>

              {/* اطلاعات */}

              <div className={styles.productInfo}>
                <h3 className={styles.productTitle}>
                  {product.name}

                  <span className={styles.productCategory}>باتری - UPS</span>
                </h3>

                {/* انتخاب نوع خرید */}

                <div
                  style={{
                    marginTop: "12px",
                    marginBottom: "12px",
                    padding: "12px",
                    borderRadius: "10px",
                    background: "#f8fafc",
                    border: "1px solid #e2e8f0",
                  }}
                >
                  <div
                    style={{
                      fontWeight: "700",
                      marginBottom: "10px",
                      fontSize: "14px",
                    }}
                  >
                    نوع خرید:
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                    }}
                  >
                    {/* با داغی */}

                    <label
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "7px",
                        cursor: "pointer",
                        fontSize: "14px",
                      }}
                    >
                      <input
                        type="radio"
                        name={`battery-option-${product.id}`}
                        checked={currentOption === "with"}
                        onChange={() => setBatteryOption(product.id, "with")}
                      />

                      <span>با داغی</span>
                    </label>

                    {/* بدون داغی */}

                    <label
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "7px",
                        cursor: "pointer",
                        fontSize: "14px",
                      }}
                    >
                      <input
                        type="radio"
                        name={`battery-option-${product.id}`}
                        checked={currentOption === "without"}
                        onChange={() => setBatteryOption(product.id, "without")}
                      />

                      <span>بدون داغی</span>
                    </label>
                  </div>
                </div>

                {/* قیمت */}

                <p className={styles.productPrice}>
                  <span className={styles.priceLabel}>قیمت:</span>

                  <strong>{currentPrice.toLocaleString()}</strong>

                  {" تومان"}
                </p>

                {/* موجودی و سبد */}

                {!isProductAvailable(product.name) ? (
                  <div className={styles.outOfStock}>ناموجود</div>
                ) : inCart ? (
                  <div className={styles.quantityControl}>
                    {/* کم کردن */}

                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        removeItem(product.id);
                      }}
                      className={styles.quantityBtn}
                      aria-label="کاهش تعداد"
                    >
                      <Minus size={16} />
                    </button>

                    {/* تعداد */}

                    <span className={styles.quantityCount}>{quantity}</span>

                    {/* زیاد کردن */}

                    <button
                      onClick={(e) => handleIncrease(product, e)}
                      className={styles.quantityBtn}
                      aria-label="افزایش تعداد"
                    >
                      <Plus size={16} />
                    </button>
                  </div>
                ) : (
                  <button
                    onClick={(e) => handleAddToCart(product, e)}
                    className={styles.addToCartBtn}
                  >
                    <ShoppingCart size={18} />
                    افزودن به سبد خرید
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default UpsCards;
